module.exports = __webpack_public_path__ + "img/plan02_text04.05ee6fd4.png";